interface Ifoot {
  preparedBy: string | null | undefined;
  approvedBy: string | null | undefined;
}
const TFoot = ({ preparedBy, approvedBy }: Ifoot) => {
  return (
    <tfoot>
      <tr>
        <th colSpan={10} align="left">
          Revision History:- Tool Loading & un-loading date mention, Re-sharping
          Freq. added.
        </th>
      </tr>
      <tr>
        <th colSpan={5} align="left">
          Prepared By: {preparedBy}
        </th>
        <th colSpan={5} align="left">
          Approved By: {approvedBy}
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
